import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class CodeExportLicListItem extends SearchModelBase {
    code: string = '';
    description: string = '';
    cid: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'Code', width: 60, dataIndex: 'code'}),
        XCol.Create({ col: 1, text: 'Description', width: 600, dataIndex: 'description'})
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: CodeExportLicListItem.prototype.code, orderByAscending: true };

    public static formatData(data: CodeExportLicListItem[]) {
        return data.map((d: CodeExportLicListItem) => ({
          ...d,
        }));
    }

}
